import React, { Component } from 'react';
import i18n from '../../views/Pages/Login/i18n';
import { Query } from 'react-apollo';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { getBusinessPartnerMiddleQuery } from '../../queries/Queries';

class CustomerSearch extends Component {
  constructor(props) {
    super(props);
    this.state = { options: [{ id: this.props.value, name: '' }] };
    this.nameCache = new Map();
    this.nameCache.set('', '');
    this.nameCache.set(this.props.value, '');
  }

  render() {
    const { value, onChange, formContext } = this.props;

    return (
      <Query
        query={getBusinessPartnerMiddleQuery}
        variables={{
          orderBy: 'name',
          where: `lower(name) like '%${this.state.query ? this.state.query : 'meter'}%' or id = '${this.props.value}'`,
        }}
      >
        {(result) => (
          <div>
            <AsyncTypeahead
              ref={(ref) => (this.typeahead = ref)}
              placeholder={i18n.t('search.searchInput')}
              isLoading={result.loading}
              disabled={!!result.error}
              onSearch={(query) => {
                this.setState({ query });
              }}
              cssclassName='md-12'
              options={result.data && result.data.businessPartner ? result.data.businessPartner : []}
              filterBy={['name']}
              labelKey='name'
              selectHintOnEnter={true}
              onChange={(selected) => {
                if (selected[0]) {
                  if (formContext && typeof formContext.handleChanges === 'function') {
                    const meterPoints =
                      selected[0].mDMBPEstateList &&
                      selected[0].mDMBPEstateList
                        .map((one) => one.mDMEstate.mDMMeterPointList.map((two) => two.name))
                        .flat();
                    formContext.handleChanges('customerMeterPoints', meterPoints);
                    formContext.handleChanges('customer', selected[0].id);
                  }
                  onChange(selected[0].id);
                }
              }}
              selected={
                value
                  ? [
                      result.data && result.data.businessPartner
                        ? result.data.businessPartner.reduce((acc, curr) => {
                            curr.id === value ? (acc = curr) : null;
                            return acc;
                          }, {})
                        : { name: '' },
                    ]
                  : [{ name: '' }]
              }
            />
            {result.error && (
              <div className='alert alert-danger mt-2' role='alert'>
                Error loading customers. Please try again.
              </div>
            )}
          </div>
        )}
      </Query>
    );
  }
}

export default CustomerSearch;
